import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { Modal, Field } from '../ui/Modal';
import { Icon } from '../ui/Icon';
import { api, ApiError } from '../../lib/api';
import { toast } from '../../stores/toast.store';

/**
 * Cambio password: modalità 'self' (richiede la password attuale) oppure
 * 'admin' (reset della password di un altro utente, serve permesso SETTINGS=Admin).
 */
export function PasswordModal({ onClose, userId, userName, mode }: {
  onClose: () => void;
  userId: string;
  userName?: string;
  mode: 'self' | 'admin';
}) {
  const self = mode === 'self';
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');

  const mismatch = confirm.length > 0 && next !== confirm;
  const canSubmit = next.length >= 8 && next === confirm && (!self || current.length > 0);

  const save = useMutation({
    mutationFn: () => api.post(`/users/${userId}/password`, self ? { password: next, currentPassword: current } : { password: next }),
    onSuccess: () => { toast.ok(self ? 'Password aggiornata' : 'Password reimpostata', userName); onClose(); },
    onError: (e) => toast.alert('Operazione non riuscita', e instanceof ApiError ? e.message : 'Riprova'),
  });

  return (
    <Modal
      title={self ? 'Cambia password' : `Reimposta password${userName ? ` · ${userName}` : ''}`}
      kicker={self ? 'Il tuo account' : 'Amministrazione utenti'}
      onClose={onClose}
      size="md"
      footer={
        <>
          <button className="btn btn-ghost" onClick={onClose}>Annulla</button>
          <div className="spacer" />
          <button className="btn btn-primary" disabled={!canSubmit || save.isPending} onClick={() => save.mutate()}>
            <Icon name="lock" size={12} /> {self ? 'Aggiorna password' : 'Reimposta password'}
          </button>
        </>
      }
    >
      <div className="form-section">
        <div className="form-grid">
          {self && (
            <Field label="Password attuale" required span={12}>
              <input className="inp" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} autoFocus />
            </Field>
          )}
          <Field label="Nuova password" required hint="Almeno 8 caratteri" span={12}>
            <input className="inp" type="password" minLength={8} value={next} onChange={(e) => setNext(e.target.value)} autoFocus={!self} />
          </Field>
          <Field label="Conferma nuova password" required span={12}>
            <input className="inp" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          </Field>
          {mismatch && <div className="col-span-12 text-[13px]" style={{ color: 'var(--alert)' }}>Le password non coincidono.</div>}
          {!self && <div className="col-span-12 text-[13px] mute">L'utente userà la nuova password al prossimo accesso.</div>}
        </div>
      </div>
    </Modal>
  );
}
